export default __webpack_public_path__ + "122cbe5a73442acfd19c17cc0060ef2f.svg";